<div class="user-container">
  <h2 class="user-title">User List</h2>
  <div class="user-filter-bar">
    <input
      type="text"
      class="user-search-input"
      placeholder="Search by name or email..."
      [(ngModel)]="userSearchTerm"
      (ngModelChange)="onSearchChange()"
    />
  </div>
  <button
    class="btn btn-primary addUser"
    data-bs-toggle="modal"
    data-bs-target="#staticBackdrop"
  >
    Add User
  </button>
  <table
    *ngIf="users && users.length && !loading; else loadingState"
    class="user-table"
  >
    <thead>
      <tr>
        <th>Name</th>
        <th>Email</th>
        <th>Role</th>
        <th>IP Address</th>
        <th>Actions</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let user of paginatedUsers"
        [class.deactivated-row]="!user.isActive"
        [class.current-user-row]="user.userName === currentUsername"
        (mouseenter)="hoveredUser = user.email"
        (mouseleave)="hoveredUser = null"
      >
        <td>{{ user.name }}</td>
        <td>{{ user.email }}</td>
        <td>
          <span
            class="role-badge"
            [ngClass]="{
              'role-admin': user.role === 'Admin',
              'role-store-admin': user.role === 'StoreAdmin',
              'role-store-user': user.role === 'StoreUser',
            }"
          >
            {{ user.role }}
            <span *ngIf="user.role === 'StoreAdmin'">⭐</span>
          </span>
        </td>
        <td>{{ user.ipAddress || "N/A" }}</td>
        <td>
          <!-- ACTIVE USER -->
          <ng-container *ngIf="user.isActive; else deactivatedUser">
            <button
              *ngIf="user.userName !== currentUsername"
              class="btn btn-outline-danger me-2"
              (click)="deactivateUser(user)"
            >
              Deactivate
            </button>

            <button
              class="btn btn-outline-warning me-2"
              (click)="openResetPassword(user)"
            >
              Reset Password
            </button>

            <button
              class="btn btn-outline-secondary"
              (click)="openEditUser(user)"
            >
              Edit
            </button>

            <span
              *ngIf="user.userName === currentUsername"
              class="text-muted fst-italic ms-2"
            >
              (You)
            </span>
          </ng-container>

          <!-- DEACTIVATED USER -->
          <ng-template #deactivatedUser>
            <span class="deactivated-badge me-2"> Deactivated </span>

            <button
              class="btn btn-outline-success btn-sm"
              (click)="reactivateUser(user)"
            >
              Reactivate
            </button>
          </ng-template>
        </td>

        <td class="token-cell">
          <div class="copy-wrapper">
            <!-- <button 
                        class="copy-btn" 
                        [class.visible]="hoveredUser === user.email" 
                        (click)="copyToken(user.apiKey)">
                        Copy Token
                      </button> -->
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <!-- EditUser modal -->
  <div class="modal fade" id="editUserModal" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit User</h5>
          <button class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <form #editForm="ngForm" class="edit-user-form">
          <!-- Username -->
          <div class="form-group readonly-group">
            <label class="form-label muted-label">Username</label>
            <input
              type="text"
              class="form-control readonly-input"
              [value]="editUser.userName"
              readonly
            />
          </div>

          <!-- Name -->
          <div class="form-group">
            <label class="form-label">Full Name</label>
            <input
              type="text"
              class="form-control"
              name="name"
              [(ngModel)]="editUser.name"
              required
            />
          </div>

          <!-- Email -->
          <div class="form-group">
            <label class="form-label">Email Address</label>
            <input
              type="text"
              class="form-control"
              name="email"
              [(ngModel)]="editUser.email"
              required
              pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
              #emailCtrl="ngModel"
            />

            <div
              class="text-danger mt-1"
              *ngIf="emailCtrl.invalid && emailCtrl.touched"
            >
              <small *ngIf="emailCtrl.errors?.['required']">
                Email is required
              </small>
              <small *ngIf="emailCtrl.errors?.['pattern']">
                Enter a valid email
              </small>
            </div>
          </div>

          <div class="modal-footer custom-footer">
            <button class="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>

            <button
              class="btn btn-primary"
              (click)="updateUser()"
              [disabled]="editForm.invalid"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Reset password modal -->
  <div class="modal fade" id="resetPasswordModal" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Reset Password</h5>
          <button class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label">New Password</label>

            <div class="input-group">
              <input
                [type]="showPassword ? 'text' : 'password'"
                class="form-control"
                [(ngModel)]="newPassword"
                placeholder="Enter new password"
              />

              <button
                type="button"
                class="btn btn-outline-secondary"
                (click)="togglePassword()"
              >
                <i
                  class="bi"
                  [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"
                ></i>
              </button>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" data-bs-dismiss="modal">
            Cancel
          </button>

          <button class="btn btn-warning" (click)="confirmResetPassword()">
            Reset Password
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="pagination-container"
    *ngIf="filteredUsers().length > pageSize && !loading"
  >
    <button
      class="btn btn-secondary"
      (click)="previousPage()"
      [disabled]="pageNumber === 1"
    >
      Previous
    </button>

    <button
      *ngFor="let page of visiblePages()"
      class="btn"
      [class.active]="page === pageNumber"
      (click)="goToPage(page)"
    >
      {{ page }}
    </button>

    <button
      class="btn btn-secondary"
      (click)="nextPage()"
      [disabled]="pageNumber >= totalPages()"
    >
      Next
    </button>
  </div>

  <div class="no-users" *ngIf="users && users.length === 0">
    No users found.
  </div>
</div>
<!-- modal -->
<div
  class="modal fade"
  id="staticBackdrop"
  (shown.bs.modal)="resetAddUserForm(addUserForm)"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="staticBackdropLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">Add new user</h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="onModalClose()"
        ></button>
      </div>
      <form #addUserForm="ngForm">
        <div class="modal-body">
          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >Name</label
            >
            <input
              type="text"
              class="form-control"
              id="exampleFormControlInput1"
              [(ngModel)]="name"
              placeholder="John Doe"
              [disabled]="disabled"
            />
          </div>
          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >Email address</label
            >
            <input
              type="email"
              class="form-control"
              name="addEmail"
              [(ngModel)]="email"
              placeholder="name@example.com"
              required
              pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
              #addEmailCtrl="ngModel"
              [disabled]="disabled"
            />

            <div
              class="text-danger mt-1"
              *ngIf="addFormSubmitted && addEmailCtrl.invalid"
            >
              <small *ngIf="addEmailCtrl.errors?.['required']">
                Email is required
              </small>

              <small *ngIf="addEmailCtrl.errors?.['pattern']">
                Enter a valid email address
              </small>
            </div>
          </div>
          <div class="mb-3">
            <label for="exampleFormControlInput1" class="form-label"
              >IP address</label
            >
            <input
              type="email"
              class="form-control"
              id="exampleFormControlInput3"
              [(ngModel)]="ipAddress"
              [disabled]="disabled"
            />
          </div>
          <div class="mb-3">
            <label for="roleSelect" class="form-label">Role</label>
            <select
              id="roleSelect"
              class="form-select"
              [(ngModel)]="selectedRole"
              [disabled]="disabled"
            >
              <option value="" disabled selected>Select role</option>
              <option value="StoreAdmin">StoreAdmin</option>
              <option value="StoreUser">StoreUser</option>
            </select>
          </div>
        </div>
      </form>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
          (click)="onModalClose()"
        >
          Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onAddUser(addUserForm)"
          [disabled]="disabled"
        >
          Add User
        </button>
      </div>
      <!-- <div *ngIf="token && isToken" class="token-display mt-2">
                <label class="form-label">Token:</label>
                <div class="input-group">
                    <input type="text" class="form-control" [value]="token" readonly>
                    <button class="btn btn-outline-secondary" type="button" (click)="copyToken(token)">Copy</button>
                </div>
            </div> -->

      <div *ngIf="username" class="mt-3 border rounded p-3">
        <div class="row align-items-center">
          <div class="col-md-10">
            <div class="mb-2">
              <label class="form-label mb-1 ms-1">Token</label>
              <input
                type="text"
                class="form-control"
                [value]="token"
                readonly
              />
            </div>
            <div class="row g-2">
              <div class="col-md-6">
                <input
                  type="text"
                  class="form-control"
                  [value]="username"
                  readonly
                />
              </div>
              <div class="col-md-6">
                <input
                  type="text"
                  class="form-control"
                  [value]="password"
                  readonly
                />
              </div>
            </div>
          </div>
          <div class="col-md-2 d-grid">
            <button class="btn btn-outline-primary h-100" (click)="copyToken()">
              Copy All
            </button>
          </div>
        </div>
      </div>
      <!-- <div *ngIf="username" class="token-display mt-2">
        <label class="form-label">Token:</label>
        <div class="input-group">
          <input type="text" class="form-control" [value]="token" readonly />
          <input type="text" class="form-control" [value]="username" readonly />
          <input type="text" class="form-control" [value]="password" readonly />
          <button
            class="btn btn-outline-secondary"
            type="button"
            (click)="copyToken()"
          >
            Copy
          </button>
        </div>
      </div> -->
    </div>
  </div>
</div>

<ng-template #loadingState>
  <div class="loading">
    <div class="scanner-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        class="bi bi-upc-scan me-2 scanner-icon"
        viewBox="0 0 16 16"
      >
        <path
          d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5M.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5M3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0z"
        />
      </svg>
      <div class="scanner-line"></div>
    </div>
  </div>
</ng-template>
